export default {
    chatBot: 0,
    searchBot: 1
}